import { getBidEndpoints, IGetBidsListDTO, IGetBidsListResponse } from '@/models/bidding.model';
import { ApiResponse, httpClient } from '@/utils';

class BiddingAPI {
  static getBidsList({
    propertyId,
    cursor,
    limit,
    with_co_bidders,
  }: IGetBidsListDTO): ApiResponse<IGetBidsListResponse> {
    const { GET_BIDS_LIST } = getBidEndpoints({ propertyId });

    return httpClient.get<IGetBidsListResponse>(GET_BIDS_LIST, {
      params: {
        ...(cursor && { cursor }),
        ...(limit && { limit }),
        ...(with_co_bidders !== undefined && { with_co_bidders }),
      },
    });
  }
}

export default BiddingAPI;
